module.exports = __webpack_public_path__ + "img/party_rino.2d678392.png";